// pages/_app.js
import { Provider } from "react-redux";
import store from "../store";
import AppRoutes from "../routes/AppRoutes";
import "../app/globals.css";
import { log } from '../routes/logger';
export default function App({ Component, pageProps }) {
 
  //log("Hello from frontend 🚀")
  return (
    <Provider store={store}>
      <AppRoutes Component={Component} pageProps={pageProps} />
    </Provider>
  );
}
